import { render } from "./AppSecondaryButton.vue?vue&type=template&id=c82536ac&scoped=true"
import script from "./AppSecondaryButton.vue?vue&type=script&lang=js"
export * from "./AppSecondaryButton.vue?vue&type=script&lang=js"

import "./AppSecondaryButton.vue?vue&type=style&index=0&id=c82536ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c82536ac"]])

export default __exports__